const Hero = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/0145d3963775ae00477b43dd84d99a2a.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/60 to-black/70"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-32 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Content */}
        <div className="flex-1 text-center lg:text-left">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 border border-orange-400/40 text-orange-300 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-8">
            <span className="w-2 h-2 bg-orange-400 rounded-full inline-block"></span>
            Professional Drainage Protection
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6">
            Protect Your Property<br />
            With <span className="text-orange-400">24/7 Drainage</span><br />
            Maintenance Cover
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-xl mx-auto lg:mx-0 leading-relaxed">
            Never worry about blocked drains again. Our maintenance plans give you round-the-clock emergency coverage, priority response, and complete peace of mind — all for less than you think.
          </p>

          {/* Stats Row */}
          <div className="flex flex-wrap justify-center lg:justify-start gap-8 mb-10">
            {[
              { value: '500+', label: 'Properties Protected' },
              { value: '24/7', label: 'Emergency Cover' },
              { value: '15+', label: 'Years Experience' },
            ].map((stat) => (
              <div key={stat.label} className="text-center lg:text-left">
                <div className="text-3xl font-extrabold text-orange-400">{stat.value}</div>
                <div className="text-sm text-gray-400 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <button
              onClick={() => scrollTo('pricing')}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-base px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-orange-500/30"
            >
              Start from £7.99/Month
            </button>
            <button
              onClick={() => scrollTo('plans')}
              className="border-2 border-white/60 hover:border-white text-white font-bold text-base px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap hover:bg-white/10"
            >
              View All Plans
            </button>
          </div>
        </div>

        {/* Right Feature Cards */}
        <div className="flex-shrink-0 w-full lg:w-80 flex flex-col gap-4">
          {[
            { icon: 'ri-shield-check-line', title: '24/7 Emergency Callout', desc: 'Round-the-clock response whenever you need us most.' },
            { icon: 'ri-camera-line', title: 'Annual CCTV Survey', desc: 'Full inspection of your drainage system every year.' },
            { icon: 'ri-tools-line', title: 'Parts & Labour Included', desc: 'No hidden costs — everything is covered in your plan.' },
            { icon: 'ri-phone-line', title: 'Priority Response', desc: 'Plan members jump the queue for faster service.' },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-4 flex items-start gap-4 hover:bg-white/15 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-orange-500/20 rounded-xl flex-shrink-0">
                <i className={`${item.icon} text-orange-400 text-xl`}></i>
              </div>
              <div>
                <div className="text-white font-semibold text-sm">{item.title}</div>
                <div className="text-gray-400 text-xs mt-1 leading-relaxed">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-white/50 text-xl"></i>
      </div>
    </section>
  );
};

export default Hero;
